<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <v-icon icon="receipt_long" :title="t('component.iconEbom.title')" />
</template>

<style scoped lang="scss"></style>
